<template>
  <div>
    <el-button class="goBack" @click="goBack">返回</el-button>
   <div class="roadInfoContent">
      <div class="inputContain">
        <div class="inputContent">
          <div class="inputitem">
            <div class="inputLeft">道路名称</div>
            <div class="inputRight">{{roadInfo.name}}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">道路类型</div>
            <div class="inputRight">{{roadInfo.roadType == 0?'标准道路':'非标准道路'}}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">道路创建时间</div>
            <div class="inputRight">{{roadInfo.createTime}}</div>
          </div>
        </div>
        <div class="inputContent">
          
          <div class="inputitem">
            <div class="inputLeft">道路负责人</div>
            <div class="inputRight">{{roadInfo.principal}}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">道路联系电话</div>
            <div class="inputRight">{{roadInfo.phone}}</div>
          </div>
          <div class="inputitem">
            <div class="inputLeft">已创建层</div>
            <div class="inputRight">{{roadInfo.layers}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="canvasCon" v-for="(j,k) in roadTableVoList" :key="k">
      <div class="title">
        <span class="line"></span>
        <span class="name">{{j.roadName}}</span>
        <span class="area">{{j.area}} m²</span>
      </div>
      <div class="order"  v-if="sourceType">
        <div class="up" @click="orderFun('up',k)"></div>
        <div class="down" @click="orderFun('down',k)"></div>
      </div>
      <div class="canvasCon-contain">
        <div class="roadCon">
          <div class="canvas-container2">
            <canvas class="dhCanvas" id="unroad1" width="550" height="507"></canvas>
            <canvas class="dhCanvas" :id="'unroad'+j.id" width="550" height="507"></canvas>
          </div>
          <!-- <div class="lineShow"></div> -->
          <div class="infoShow"  v-if="sourceType">
            <el-button class="edit" type="danger" @click="editAssignRoad(j.id)"
              >修改</el-button
            >
            <el-button class="delete" type="warning" @click="deleteAssignRoad(j.id)"
              >删除</el-button
            >
          </div>
        </div>
        <div class="sectionCon" v-for="(item,index) in j.roadSections" :key="index">
          <div class="sectionItem">
            <div class="canvas-container2">
              <canvas class="dhCanvas" :id="'canvas'+item.id" width="550" height="507"></canvas>
            </div>
            <!-- 修改删除作业块 -->
            <div class="infoShow">
              <el-button class="edit" type="danger" @click="editRoadSection(roadId,j.id,item.id)" v-if="sourceType"
                >修改</el-button
              >
              <el-button class="delete" type="warning" plain @click="delRoadSection(item.id)" v-if="sourceType"
                >删除</el-button
              >
              <div class="title1">
                <span class="line"></span>
                <span class="name">{{item.sectionName}}</span>
                <span class="area">{{item.area}} m²</span>
              </div>
            </div>
          </div>
        </div>
        <div class="addSectionCon" v-if="sourceType">
          <div class="addSection" @click="toRoadSection(roadId,j.id)">
            <div class="addSectionText">添加新的作业块</div>
          </div>
        </div>
      </div>
      
    </div>
    <el-pageCover
          class="pageBlock"
          :style="'position:absolute;right:20px;top:'+pageConTop"
          :pageMsg="pageMsg"
          :page-sizes="[5]"
          @sizeChange="pageSizeChange"
          @currentChange="currentPageChange"
    ></el-pageCover>
    <div class="addceng" @click="toAssignRoad"  :style="'top:'+addcengTop"  v-if="sourceType">添加新的层</div>
  </div>
</template>

<script>
import { fabric } from "fabric";
// import canvasMix from "../../utils/canvasMix";
// import { setGrid } from "../../utils/canvasSet";
import {
//   getRoadCordInfo,
  getRoadInfo,
  getRoadInfoDetails,
  // getRoadSections,
  deleteRoadSection,
  deleteRoad,
  resortRoadOrder
} from "../../utils/api";
// import { changeRoadPointer } from "../../utils/commons";
import ElPageCover from "../../components/overall/ElPageCover"
export default {
  name: "app",
//   mixins: [canvasMix],
  data() {
    return {
      arrowList: [
        {
          name: "道路管理",
          path: "/transfer/roadList",
        },
        {
          name: "道路详情",
          path: "/transfer/unroadInfo",
        },
      ],
      bool:false,
      scaleCode:"",
      leftDistance:"",
      topDistance:"",
      getChangeObj:"",
      roadId: "",
      roadType: "",
      roadInfo: "",
      panning: false,
      roadTableVoList:[],
      cengids:'',//层排列顺序
      sourceType:'',
      pageMsg: {
          pageSize: 5,
          pageNo: 1,
          totalRecords: 0
      },
    };
  },
  computed: {
    addcengTop(){
      if(this.sourceType){
        return this.roadTableVoList.length*705+195+'px'
      }else{
        return this.roadTableVoList.length*705+170+'px'
      }
    },
    pageConTop(){
      return this.roadTableVoList.length*705+135+'px'
    }
  },
  created() {},
  mounted() {
    this.$store.commit("setArrowList", this.arrowList);
    this.roadId = this.$route.query.id || this.$store.state.nowRoadId;
    this.$store.commit("setNowRoadId", this.roadId);
    this.getRoadInfoDetailsFun()
  },
  beforeDestroy() {
    this.$store.commit("setNowRoadId", "");
  },
  watch:{
    roadTableVoList:function(){
      // console.log(this.roadTableVoList,'road')
      this.$nextTick(function () {
        let _roadTableVoList=JSON.parse(JSON.stringify(this.roadTableVoList))
        _roadTableVoList.map(i=>{
          let changeObj = this.changeUnRoadPointer(550, 507, i);
          this.getChangeObj = changeObj[0];
          this.$store.commit("setScaleCode", this.scaleCode);
          var canvas = new fabric.Canvas("unroad"+i.id, {
            perPixelTargetFind: true,
          });
          canvas.selectable = false;
          let sectionDataMap=JSON.parse(JSON.stringify(i.roadSections))
          this.initCanvas(canvas, this.getChangeObj);//非标道路绘制
          this.doInit(this.getChangeObj,sectionDataMap);//右侧详情绘制
        })
      });
    }
  },
  methods: {
    pageSizeChange(size){
      this.pageMsg.pageSize=size;
      this.getRoadInfoDetailsFun()
    },
    currentPageChange(index){
      this.pageMsg.pageNo=index;
      this.getRoadInfoDetailsFun()
    },
    //对层进行排序
    orderFun: function(type,i){
      console.log(this.roadTableVoList,'this.roadTableVoList')
      let _roadTableVoList=JSON.parse(JSON.stringify(this.roadTableVoList))
      let maxIndex=_roadTableVoList.length
      if(maxIndex==1){
        return
      } else if(i==maxIndex-1 && type=='down'){
        return
      }else if(i==0 && type=='up') {
        return
      }
      let arr=[]
      let ceng=[]
      if(type=='up'){
        _roadTableVoList.map((item,index)=>{
          if(index==i-1){
            arr.push(_roadTableVoList[i])
          }else if(index==i){
            arr.push(_roadTableVoList[i-1])
          }else{
            arr.push(item)
          }
        })
      }else if(type=='down'){
        _roadTableVoList.map((item,index)=>{
          if(index==i){
            arr.push(_roadTableVoList[i+1])
          }else if(index==i+1){
            arr.push(_roadTableVoList[i])
          }else{
            arr.push(item)
          }
        })
      }
      
      arr.map(j=>{
          ceng.push(j.id)
        })
      this.cengids=ceng.join(',')
      resortRoadOrder({ids:this.cengids}).then(()=>{
        this.roadTableVoList=JSON.parse(JSON.stringify(arr))
      })
    },
    //获取作业详情
    getRoadInfoDetailsFun: function(){
      let params = {
        id: this.roadId,
        pageSize:this.pageMsg.pageSize,
        pageNo:this.pageMsg.pageNo
      };
      getRoadInfo({roadId: this.roadId,pageSize: 100}).then((res) => {
        this.roadInfo = res.data.content.info;
        this.sourceType = res.data.content.info.sourceType
        this.roadType = res.data.content.info.roadType;
      })
       getRoadInfoDetails(params).then((res) => {
        this.roadTableVoList=JSON.parse(JSON.stringify(res.data.content.info.list))
        this.pageMsg.totalRecords=res.data.content.info.totalRecords
        this.$nextTick(function () {
        res.data.content.info.list.map(i=>{
          let changeObj = this.changeUnRoadPointer(550, 507, i);
          this.getChangeObj = changeObj[0];
          this.$store.commit("setScaleCode", this.scaleCode);
          var canvas = new fabric.Canvas("unroad"+i.id, {
            perPixelTargetFind: true,
          });
          canvas.selectable = false;
          let sectionDataMap=JSON.parse(JSON.stringify(i.roadSections))
          this.initCanvas(canvas, this.getChangeObj);//非标道路绘制
          this.doInit(this.getChangeObj,sectionDataMap);//右侧详情绘制
        })
        });
      });
    },
    doInit: function (setArr,getArr) {
      // getRoadSections({roadId: this.roadId,pageSize: 100}).then((res) => {
        // console.log(res,'section')
        // let getArr = res.data.content.info.list;
        getArr.map((item)=>{
                item.vertexList.map(item=>{
                    item.x=item.x/this.scaleCode+this.leftDistance;
                    item.y=-item.y/this.scaleCode+this.topDistance;
                })
            });
        let sections = [...getArr];
        console.log(sections,'sections')
        this.$nextTick(function () {
            sections.map((item)=>{
              var canvas1 = new fabric.Canvas("canvas"+item.id, {
                  perPixelTargetFind: true,
              });
              canvas1.clear()
              canvas1.selectable = false;
              this.setRoad(canvas1,setArr);
              this.drawSec(canvas1,item);
          })
        });
        
      // });
    },
      toAssignRoad: function () {
      this.$router.push({
        name: "UnRoadSet",
        query: { id: this.roadId, type: "add", roadType: this.roadInfo.roadType, name: this.roadInfo.name },
      });
      
    },
    editAssignRoad: function (e) {
      this.$router.push({
        name: "UnRoadSet",
        query: {
          id: this.roadId,
          cengid:e,
          type: "edit",
          roadType: this.roadType,
        },
      });
    },
    deleteAssignRoad: function (e) {
      this.$confirm("删除层会将该层下的各作业块全部删除，可能影响关联作业,请谨慎确认是否删除。", "删除层",{
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            dangerouslyUseHTMLString: true
          }
        ).then(() => {
          deleteRoad({ids:e}).then(res=>{
            if(res.data.code==200){
              this.$message({
                  message: "删除成功!",
                  type: "success"
              });
              this.getRoadInfoDetailsFun()
            }
          })
        });
    },
      initCanvas: function(canvas,setArr){
            // var that = this
            canvas.selections = false
            this.setRoad(canvas,setArr);
        },
        setRoad(canvas,setArr){
            let leftArr = setArr[0]
            let barArr = setArr[2]
            let areaArr = leftArr
            let areaPath = 'M'+' '+areaArr[0][0]+' '+areaArr[0][1]
            for(let i=1;i<areaArr.length;i++){
                areaPath += ' '+'L'+' '+areaArr[i][0]+' '+areaArr[i][1]
            }
            areaPath = areaPath + 'z'
            canvas.add(new fabric.Path(areaPath,{
                strokeWidth: 2,
                stroke: 'black',
                fill: 'RGBA(132,132,198,0)',
                // strokeDashArray: [1,1],
                selectable: false,
                hasBorders: false,
                hasControls: false,
            }))
            for(let i=0;i<barArr.length;i++){
                let barPath="";
                for(let j=0;j<barArr[i].length;j++){
                    if(j==0){
                        barPath = 'M'+' '+barArr[i][0].x+' '+barArr[i][0].y;
                    }else{
                        barPath += ' '+'L'+' '+barArr[i][j].x+' '+barArr[i][j].y;
                    }
                    canvas.add(new fabric.Text("S"+j,{
                        fontSize:12,
                        top: barArr[i][j].y+5,
                        left: barArr[i][j].x+5,   
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                        fill: 'black'
                    }));
                    canvas.add(new fabric.Circle({
                        radius: 3,
                        top: barArr[i][j].y-3,//调整中心点的X轴坐标
                        left: barArr[i][j].x-3, 
                        selectable: false,
                        hasBorders: false,
                        hasControls: false,
                        fill: '#000'
                    }))
                }
                barPath = barPath + 'z'
                canvas.add(new fabric.Path(barPath,{
                    strokeWidth: 1,
                    stroke: 'black',
                    fill: 'RGBA(132,132,198,0.2)',
                    // strokeDashArray: [1,1],
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                }));
            }
            for(let i=0;i<setArr[1].length;i++){
                canvas.add(new fabric.Text(setArr[1][i].name,{
                    fontSize:14,
                    top: setArr[0][i][1]*1.05-15,
                    left: setArr[0][i][0]*1.05-28,   
                    selectable: false,
                    hasBorders: false,
                    hasControls: false,
                    fill: 'black'
                }));    
            }
            // this.setGroupFun(canvas)
        },
    changeUnRoadPointer(width,height,setObj){
        let pileNumList = []
        for(let i=0;i<setObj.vertexList.length;i++){
            pileNumList.push(setObj.vertexList[i])
        }
        let visualWidth = 50
        let visualHeight = 50
        let widthArea = width - visualWidth
        let heigthArea = height - visualHeight
        let vertexList = this.arrToArr(setObj.vertexList)
        let blockList = this.arrToArr1(setObj.blockList)
        let xcordArr = this.arrToDArr(vertexList,0)
        let ycordArr = this.arrToDArr(vertexList,1)
        let xMaxCode = this.getMaxAMin(xcordArr,'max')
        let xMinCode = this.getMaxAMin(xcordArr,'min')
        let yMaxCode = this.getMaxAMin(ycordArr,'max')
        let yMinCode = this.getMaxAMin(ycordArr,'min')
        // 获取x与y轴道路数据最大差距
        let xGap = (xMaxCode-xMinCode)>0?(xMaxCode-xMinCode):-(xMaxCode-xMinCode)
        let yGap = (yMaxCode-yMinCode)>0?(yMaxCode-yMinCode):-(yMaxCode-yMinCode)
        // 获取x与y轴对于canvas高宽的比例
        let xScale = xGap/(widthArea-50)
        let yScale = yGap/(heigthArea-50)
        //设置页面canvas比列大小
        this.scaleCode = xScale>yScale ? xScale : yScale
        // 获取缩放后的道路和障碍区数据
        let midScaledLine = this.roadScale(vertexList,this.scaleCode)
        let barScaledLine = this.roadScale1(blockList,this.scaleCode)
        // 获取缩放后的道路数据中x与y轴最小值
        let scaledXMinCode = this.getMaxAMin(this.arrToDArr(midScaledLine,0),'min').toFixed(2)
        let scaledXMaxCode = this.getMaxAMin(this.arrToDArr(midScaledLine,0),'max').toFixed(2)
        let scaledYMinCode = this.getMaxAMin(this.arrToDArr(midScaledLine,1),'min').toFixed(2)
        let scaledYMaxCode = this.getMaxAMin(this.arrToDArr(midScaledLine,1),'max').toFixed(2)
        let addX = width/2 - (scaledXMaxCode - scaledXMinCode)/2
        let addY = height/2 - (scaledYMaxCode - scaledYMinCode)/2
        // 缩放后的道路数据中x与y轴最小值移动到左边与上边的差距值
        this.leftDistance = visualHeight/2 - scaledXMinCode + addX-23
        this.topDistance = visualHeight/2 - scaledYMinCode + addY-10
        // 转换缩放后的道路的数据
        let changedMid = this.changedRoad(midScaledLine,this.leftDistance,this.topDistance)
        let changedBar = this.changedRoad1(barScaledLine,this.leftDistance,this.topDistance)
        let returnObj = [changedMid,pileNumList,changedBar]
        return [returnObj,this.scaleCode] 
    },
    arrToArr (arr){
    //转换区块
        let setArr = []
        for(let i=0;i<arr.length;i++){
            setArr.push([arr[i].x,-arr[i].y])
        }
        return setArr
    },
    arrToArr1 (arr){
    //转换障碍
        let setArr = [];
        for(let i=0;i<arr.length;i++){
            let setArr1=[];
            for(let j=0;j<arr[i].points.length;j++){
                setArr1.push({x:arr[i].points[j].x,y:-arr[i].points[j].y})
            } 
            setArr.push(setArr1);
        }
        return setArr
    },
    arrToDArr (arr,type){
        let setArr = []
        for(let i=0;i<arr.length;i++){
            setArr.push(arr[i][type])
        }
        return setArr
    },
    getMaxAMin(arr,type){
        if(type == 'max'){
            return Math.max.apply(Math,arr)
        }else if(type == 'min'){
            return Math.min.apply(Math,arr)
        }
    },
    roadScale(arr,code){
        let setArr= []
        for(let i=0;i<arr.length;i++){
            setArr.push([arr[i][0]/code,arr[i][1]/code])
        }
        return setArr
    },
    roadScale1(arr,code){
        let setArr= []
        for(let i=0;i<arr.length;i++){
            let setArr1=[];
            for(let j=0;j<arr[i].length;j++){
                setArr1.push({x:arr[i][j].x/code,y:arr[i][j].y/code})
            }
            setArr.push(setArr1)
        }
        return setArr
    },
    changedRoad(arr,x,y){
        let setArr = []
        for(let i=0;i<arr.length;i++){
            setArr.push([arr[i][0]+x,arr[i][1]+y])
        }
        return setArr
    },
    changedRoad1(arr,x,y){
        let setArr = []
        for(let i=0;i<arr.length;i++){
            let setArr1=[];
            for(let j=0;j<arr[i].length;j++){
             setArr1.push({x:arr[i][j].x*1+x,y:arr[i][j].y*1+y})
            }
            setArr.push(setArr1);
        }
        return setArr
    },
    drawSec(canvas,getArr){
        let workPath="";
        for(let i=0;i<getArr.vertexList.length;i++){
            if(i==0){
                workPath = 'M'+' '+getArr.vertexList[0].x+' '+getArr.vertexList[0].y;
            }else{
                workPath += ' '+'L'+' '+getArr.vertexList[i].x+' '+getArr.vertexList[i].y;
            }
            canvas.add(new fabric.Text("W"+i,{
                fontSize:12,
                top: getArr.vertexList[i].y+5,
                left: getArr.vertexList[i].x+5,   
                selectable: false,
                hasBorders: false,
                hasControls: false,
                fill: 'black'
            }));
            canvas.add(new fabric.Circle({
                radius: 3,
                top: getArr.vertexList[i].y-3,//调整中心点的X轴坐标
                left: getArr.vertexList[i].x-3, 
                selectable: false,
                hasBorders: false,
                hasControls: false,
                fill: '#000'
            }))
        }
        workPath = workPath + 'z'
        canvas.add(new fabric.Path(workPath,{
            strokeWidth: 1,
            stroke: 'blue',
            fill: 'RGBA(213,255,255,0.5)',
            // strokeDashArray: [1,1],
            selectable: false,
            hasBorders: false,
            hasControls: false,
        }));
    },
    
    goBack: function () {
      this.$router.push({ name: "RoadList" });
    },
    toRoadSection: function (e,e1) {
      this.$router.push({
        name: "UnRoadSection",
        query: { id: e, cengid:e1,type: "add", roadType: this.roadType },
      });
    },
    editRoadSection: function (e,e1,e2) {
      //console.log(e)
      this.$router.push({
        name: "UnRoadSection",
        query: { id: e, cengid:e1,sectionid:e2,type: "edit", roadType: this.roadType },
      });
    },
    delRoadSection: function (e) {
      //console.log(e)
      this.$confirm("删除作业块可能影响关联作业,请谨慎确认是否删除。", "删除作业块", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        dangerouslyUseHTMLString: true,
      }).then(() => {
        let params = {};
        params.ids = e;
        deleteRoadSection(params).then((res) => {
          if(res.data.code==200){
            this.$message({
              message: "删除成功!",
              type: "success",
            });
            this.getRoadInfoDetailsFun();
          }
        });
      });
    },
  },
  components: {ElPageCover},
};
</script>
<style lang="scss">
  .dhCanvas {
    position: absolute !important;
    top: 70px !important;
    left: 20px !important;
  }
  .canvas-container2{
    .canvas-container{
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    }
}
</style>
<style lang="scss" scoped="">
.goBack {
  position: fixed;
  right: 16px;
  top: 68px;
  z-index: 1000;
  height: 35px !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.roadInfoContent {
  width: 100%;
  min-height: 50px;
  padding: 0 15px;
  .inputContain {
    border-top: 1px solid rgba(225, 225, 225, 1);
    border-left: 1px solid rgba(225, 225, 225, 1);
  }
  .inputContent {
    width: 100%;
    height: 45px;
    display: flex;

    .inputitem {
      display: flex;
      width: 33.3%;
      .inputLeft {
        width: 25.8%;
        height: 45px;
        background-color: #e1e1e1;
        float: left;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 45px;
        padding-left: 16px;
        color: #555555;
        font-size: 14px;
      }
      .inputRight {
        width: 74.2%;
        height: 45px;
        background-color: #ffffff;
        float: left;
        border-bottom: 1px solid rgba(225, 225, 225, 1);
        border-right: 1px solid rgba(225, 225, 225, 1);
        line-height: 45px;
        padding-left: 16px;
        color: #555555;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
.canvasCon {
  height: 694px;
  padding: 0 15px;
  width: 1890px;
  margin: 0 auto;
  margin-top: 11px;
  background-color: #ffffff;
  position: relative;
  flex-direction: row;
  border: 1px solid rgba(225, 225, 225, 1);
  padding-top: 70px;
  padding-left: 20px;
  .title{
    width: 1000px;
    height: 50px;
    font-size: 20px;
    position: absolute;
    top: 10px;
    left: 20px;
    display: flex;
    align-items: center;
    .line{
      display: inline-block;
      width: 5px;
      height: 25px;
      background: #FF0000;
      margin-right: 10px;
    }
    .name{
      font-weight: bold;
    }
    .area{
      display: inline-block;
      height: 35px;
      background: rgba(225, 235, 250, 1);
      color: #2273f8;
      margin-left: 10px;
      line-height: 35px;
      padding: 0 10px;
    }
  }
  .order{
    width: 64px;
    height: 32px;
    font-size: 20px;
    position: absolute;
    top: 20px;
    right: 20px;
    display: flex;
    align-items: center;
    .up{
      width: 32px;
      height: 32px;
      background: url('../../images/all/shangjiantou.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
    .down{
      width: 32px;
      height: 32px;
      background: url('../../images/all/xiajiantou.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .canvasCon-contain{
    width: 100%;
    height: 100%;
    overflow-x: auto;
    display: flex;
  position: relative;
    .roadCon {
      height: 600px;
      flex: none;
      width: 600px;
      border: 1px solid rgba(211, 207, 206, 1);
      display: inline-block;
      position: relative;
      .dhCanvas {
        position: absolute;
        top: 300px;
        left: 100px;
      }
      // .lineShow {
      //   width: 1px;
      //     height: 617px;
      //     position: absolute;
      //     background: rgba(225, 225, 225, 1);
      //     left: 100%;
      //     transform: translateX(-50%);
      //     top: 35px;
      // }
      .infoShow {
        width: 100%;
        .infoTypeShow {
          height: 22px;
          position: absolute;
          width: auto;
          top: 23px;
          left: 23px;
          .type {
            font-size: 14px;
            padding: 5px 8px;
            margin-right: 6px;
            float: left;
            line-height: 12px;
          }
          .type_1 {
            background: rgba(225, 235, 250, 1);
            color: #2273f8;
          }
          .type_2 {
            background: rgba(254, 235, 232, 1);
            color: #e96b5a;
          }
          .type_3 {
            background: rgba(221, 240, 229, 1);
            color: #10bd62;
          }
        }
        .edit {
          position: absolute;
          top: 22px;
          right: 91px;
        }
        .delete {
          position: absolute;
          top: 22px;
          right: 30px;
        }
      }
    }
    .sectionCon {
      flex: none;
      margin-left: 20px;
      .sectionItem {
        height: 600px;
        width: 600px;
        border: 1px solid rgba(211, 207, 206, 1);
        float: left;
        position: relative;

        .dhCanvas {
          position: absolute;
          top: 100px;
          left: 100px;
        }
        // .lineShow {
        //   width: 1px;
        //   height: 617px;
        //   position: absolute;
        //   background: rgba(225, 225, 225, 1);
        //   left: 100%;
        //   transform: translateX(-50%);
        //   top: 35px;
        // }
        .infoShow {
          width: 100%;
          .title1{
            width: 430px;
            height: 50px;
            font-size: 16px;
            position: absolute;
            top: 10px;
            left: 20px;
            display: flex;
            align-items: center;
            z-index: 100;
            .line{
              display: inline-block;
              width: 4px;
              height: 20px;
              background: #FF0000;
              margin-right: 6px;
            }
            .name{
              max-width: 290px;
              font-weight: bold;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
            }
            .area{
              display: inline-block;
              height: 28px;
              background: rgba(225, 235, 250, 1);
              color: #2273f8;
              margin-left: 6px;
              line-height: 28px;
              padding: 0 6px;
            }
          }
          .infoTypeShow {
            height: 22px;
            position: absolute;
            width: auto;
            top: 23px;
            left: 23px;
            .type {
              font-size: 14px;
              padding: 5px 8px;
              margin-right: 6px;
              float: left;
              line-height: 12px;
            }
            .type_1 {
              background: rgba(225, 235, 250, 1);
              color: #2273f8;
            }
            .type_2 {
              background: rgba(254, 235, 232, 1);
              color: #e96b5a;
            }
            .type_3 {
              background: rgba(221, 240, 229, 1);
              color: #10bd62;
            }
          }
          .edit {
            position: absolute;
            top: 22px;
            right: 91px;
          }
          .delete {
            position: absolute;
            top: 22px;
            right: 30px;
          }
        }
      }
    }
    .addSectionCon {
      height: 600px;
      width: 600px;
      flex: none;
      border: 1px solid rgba(211, 207, 206, 1);
      margin-left: 20px;
      .addSection {
        width: 100%;
        height: 100%;
        background: url("../../images/all/add.jpg") no-repeat center center;
      //   background-size: 100% 100%;
        cursor: pointer;
        position: relative;
        .addSectionText{
          position: absolute;
          left: 232px;
          top: 370px;
          // background: rgba(254, 235, 232, 1);
          color: #e96b5a;
          font-size: 18px;
          font-weight: 600;
          width: 140px;
          height: 24px;
          line-height: 24px;
          text-align: center;
        }

      }
    }
  }
  
}
.addceng{
  height: 160px;
  width: 1885px;
  padding: 0 15px;
  position: absolute;
  left: 50%;
  margin-left: -943px;
  margin-bottom: 11px;
  background-color: #ffffff;
  background-image: url('../../images/all/add.jpg');
  background-repeat: no-repeat;
  background-position: 50% 50%;
  color: #e96b5a;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  text-indent: 270px;
  line-height: 160px;
  cursor: pointer;
}

</style>